import { useTranslation } from '@frontend/i18n';
import { useSaveEligibilityReport } from '@frontend/insurance-verification-reports-writeback';
import { theme } from '@frontend/theme';
import { XIcon, Text, CheckIcon } from '@frontend/design-system';
import { useInsuranceEligibilityReportContainerContext } from '../providers/insurance-report-container.provider';

interface IStatusMessageProps {
  message: string;
  status: Omit<IProps, 'PMSName'>['status'];
}

const StatusMessage = ({ message, status }: IStatusMessageProps) => (
  <div css={{ display: 'flex' }}>
    {status === 'success' ? <CheckIcon color='success' /> : <XIcon color='error' />}
    <Text weight='bold' css={{ marginLeft: theme.spacing(1) }} color={status}>
      {message}
    </Text>
  </div>
);

interface IProps {
  status: 'success' | 'error';
  PMSName: string;
}

export const InsuranceReportWritebackStatusMessage = ({ status, PMSName }: IProps) => {
  const { t } = useTranslation('insuranceEligibilityReport');

  if (!PMSName) return null;

  if (status === 'error') {
    return <StatusMessage status='error' message={t('Failed to save report to {{PMSName}}', { PMSName })} />;
  }

  return <StatusMessage status='success' message={t('Report saved to {{PMSName}}', { PMSName })} />;
};

export const InsuranceReportWritebackStatusMessageContainer = () => {
  const {
    integrationDetails: { PMSName },
  } = useInsuranceEligibilityReportContainerContext();
  const { isEligibilityReportWritebackError, isEligibilityReportWrittenBackInPMS } = useSaveEligibilityReport();

  return (
    <>
      {isEligibilityReportWrittenBackInPMS && PMSName && (
        <InsuranceReportWritebackStatusMessage status='success' PMSName={PMSName} />
      )}
      {isEligibilityReportWritebackError && PMSName && (
        <InsuranceReportWritebackStatusMessage status='error' PMSName={PMSName} />
      )}
    </>
  );
};
